__turbopack_context__.v({
  "Checkmark": "OJWKEG_Checkmark",
  "Grid": "OJWKEG_Grid",
  "Root": "OJWKEG_Root",
  "Selected": "OJWKEG_Selected",
  "Swatch": "OJWKEG_Swatch",
  "Used": "OJWKEG_Used",
  "skeleton-loading": "OJWKEG_skeleton-loading",
});
